<template>
  <div>
    <div class="level">
      <div class="level-left">
        <router-link
          class="button is-info is-small"
          :to="{ name: 'Create Delivery' }"
        >
          <span class="icon"> <i class="fas fa-plus"></i> </span>&nbsp; Create
          new</router-link
        >
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="deliveries.data"
      :search="search"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="deliveries.totalData"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
      :placeholder="'Search by Delivery ID, Client Name & S.I or D.R #'"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column class="table-column-content-is-small" label="Ref. ID">
          {{ item.row.deliveryId }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="AREA">
          {{ item.row.area }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="S.I #">
          {{ item.row.siNum }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="S.I Date">
          {{ item.row.siDate }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="D.R #">
          {{ item.row.drNum }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="D.R Date">
          {{ item.row.drDate }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Client(s)">
          {{ item.row.clients }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="DELIVERY DATE"
        >
          {{ item.row.deliveryDate }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="TOTAL ITEM(S)"
        >
          {{ item.row.deliveryItemCount }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Status">
          <span v-if="item.row.deliveryStatusInt == 0">
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#E08A1E;color:white"
            >
              <span class="icon"> <i class="fas fa-warehouse"></i></span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 1">
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#22A7F0;color:white"
            >
              <span class="icon">
                <i class="fas fa-truck"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 2">
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#59ABE3;color:white"
            >
              <span class="icon">
                <i class="fas fa-list-ol"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 3">
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#26C281;color:white"
            >
              <span class="icon">
                <i class="fas fa-check"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 4">
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#C91F37;color:white"
            >
              <span class="icon">
                <i class="fas fa-ban"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 5">
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#F9690E;color:white"
            >
              <span class="icon">
                <i class="fas fa-truck fa-flip-horizontal"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <router-link
            class="button is-small is-warning"
            :to="{
              name: 'Edit Delivery',
              params: { deliveryId: item.row.deliveryId }
            }"
            >Edit</router-link
          >
          &nbsp;
          <button
            class="button is-small is-danger"
            @click="deleteData(item.row.deliveryId)"
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import Delete from "./Delete.vue";

export default {
  components: {
    TablePagination,
    Delete
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("delivery", {
      deliveries: state => state.deliveries,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: ""
  }),
  created() {
    this.navFromPageParam();
  },
  methods: {
    ...mapActions("delivery", ["getPaginatedData", "openDeleteModal"]),
    navFromPageParam() {
      this.$router.push({
        name: "List of Delivery",
        params: {
          page: parseInt(!this.page ? 1 : this.page),
          pageSize: parseInt(!this.perPage ? 10 : this.perPage),
          searchQuery: !this.search ? null : this.search
        }
      });

      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      });
    },
    deleteData(id) {
      this.openDeleteModal({
        showDeleteModal: true,
        delivery: {
          deliveryId: id
        }
      });
    },
    refreshTable() {
      this.default();
    },
    default() {
      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      });
    }
  },
  watch: {
    perPage(val) {
      this.navFromPageParam();
    },
    page(val) {
      this.navFromPageParam();
    },
    search(val) {
      this.navFromPageParam();
    }
  }
};
</script>
